import { Icon } from '@iconify/react';

const BillSeriesModal = ({
    show,
    handleClose,
    handleSubmit,
    formData,
    setFormData,
    editId,
    billingTypes,
    loading
}) => {
    if (!show) return null;

    return (
        <div className="modal-backdrop-custom" onClick={handleClose}>
            <div className="modal-content-custom card radius-16 border-0 shadow-lg" onClick={(e) => e.stopPropagation()}>
                <div className="card-header py-10 px-16 border-bottom d-flex align-items-center justify-content-between">
                    <h6 className="fw-semibold mb-0">{editId ? 'Edit' : 'Add New'} Bill Series</h6>
                    <button
                        onClick={handleClose}
                        className="btn btn-link p-0 text-secondary-light"
                    >
                        <Icon icon="mdi:close" className="text-xl" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="card-body p-24">
                        <div className="row gy-3">
                            <div className="col-12">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Billing Type <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select radius-8 h-48-px"
                                    value={formData.billingType}
                                    onChange={(e) => setFormData({ ...formData, billingType: e.target.value })}
                                    required
                                >
                                    <option value="">Select Billing Type</option>
                                    {billingTypes.map(type => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-6">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Prefix <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8 h-48-px"
                                    value={formData.prefix}
                                    onChange={(e) => setFormData({ ...formData, prefix: e.target.value })}
                                    placeholder="e.g., INV"
                                    required
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Suffix
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8 h-48-px"
                                    value={formData.suffix}
                                    onChange={(e) => setFormData({ ...formData, suffix: e.target.value })}
                                    placeholder="e.g., 2024"
                                />
                            </div>
                            <div className="col-6">
                                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                    Start Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control radius-8 h-48-px"
                                    value={formData.startNumber}
                                    onChange={(e) => setFormData({ ...formData, startNumber: parseInt(e.target.value) || '' })}
                                    placeholder="e.g., 1001"
                                    required
                                    min="1"
                                />
                            </div>
                            {editId && (
                                <div className="col-6">
                                    <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                                        Current Number
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control radius-8 h-48-px"
                                        value={formData.currentNumber}
                                        onChange={(e) => setFormData({ ...formData, currentNumber: parseInt(e.target.value) || '' })}
                                        placeholder="e.g., 1045"
                                        min="1"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Preview */}
                        {formData.prefix && formData.startNumber && (
                            <div className="mt-16 p-16 bg-info-50 radius-8">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <Icon icon="mdi:eye" className="text-info-600" />
                                    <span className="text-sm fw-medium text-info-600">Preview</span>
                                </div>
                                <code className="d-block text-center py-8 bg-white radius-4 fw-bold">
                                    {formData.prefix}-{formData.startNumber}{formData.suffix ? `-${formData.suffix}` : ''}
                                </code>
                            </div>
                        )}
                    </div>
                    <div className="card-footer py-10 px-16 border-top d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="btn btn-outline-secondary px-20 py-10 radius-8"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn px-20 py-10 radius-8 text-white"
                            style={{ backgroundColor: '#f59e0b' }}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            ) : (
                                <Icon icon={editId ? "mdi:check" : "mdi:plus"} className="text-lg me-1" />
                            )}
                            {editId ? 'Update' : 'Add'} Bill Series
                        </button>
                    </div>
                </form>
            </div>

            <style>{`
                .modal-backdrop-custom {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1050;
                    animation: fadeIn 0.2s ease;
                }

                .modal-content-custom {
                    width: 100%;
                    max-width: 500px;
                    margin: 16px;
                    animation: slideUp 0.3s ease;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                /* Compact input height for BillSeries modal (was 48px). */
                .h-48-px { height: 34px; font-size: 12px; padding-top: 4px; padding-bottom: 4px; }
                .h-48-px + code, .h-48-px ~ code { font-size: 12px; }
            `}</style>
        </div>
    );
};

export default BillSeriesModal;
